import { render } from "./equipment.svg?vue&type=template&id=625aeaea?inline"
const script = {}
script.render = render

export default script